module.exports = __webpack_public_path__ + "static/media/crocodile.c0aba2bd.mp4";